// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"Pagination_loadingContainer__ECs8j"};